import setCookieForSubdomain from './browser-storage/set-cookie-for-subdomain';
import { storageKeys } from './browser-storage/storage-keys';
import isPrerender from './is-prerender';

const lastVisitedWorld = {
    get() {
        if (isPrerender()) {
            return null;
        }

        return localStorage.getItem(storageKeys.general.lastVisitedWorld);
    },
    set(world: string) {
        if (window.location.pathname.indexOf(`/${world}`) === 0) {
            localStorage.setItem(storageKeys.general.lastVisitedWorld, world);
            setCookieForSubdomain(storageKeys.general.lastVisitedWorld, world);
        }
    }
};

export default lastVisitedWorld;
